"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateEmail = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../actions");
var initialState = {
  loading: false
};
var updateEmail = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.updateEmailAction.pending, function (state) {
    state.loading = true;
  });
  builder.addCase(_actions.updateEmailAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.updateEmailAction.fulfilled, function (state) {
    state.loading = false;
  });
});
exports.updateEmail = updateEmail;